var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5716 20.5813L15.6436 15.68C19.0966 12.2057 19.2018 6.62856 15.8824 3.02649C12.5629 -0.575588 6.99579 -0.925419 3.25153 2.23278C-0.492729 5.39098 -1.0865 10.9374 1.90437 14.8166C4.89524 18.6958 10.4102 19.5324 14.417 16.7146L19.441 21.7386C19.7562 22.0324 20.2474 22.0237 20.552 21.719C20.8567 21.4144 20.8654 20.9232 20.5716 20.608V20.5813ZM1.73975 9.28002C1.73975 5.1563 5.08269 1.81335 9.20641 1.81335C13.3301 1.81335 16.6731 5.1563 16.6731 9.28002C16.6731 13.4037 13.3301 16.7467 9.20641 16.7467C5.08269 16.7467 1.73975 13.4037 1.73975 9.28002Z",
    fill: "#D01422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.16f5bd9b.svg";
export { ForwardRef as ReactComponent };